export enum TipoDepositoEnum {
    Boleto = 1,
    Deposito = 2,
    PIX = 5
}
